import { motion } from "framer-motion";

const bubbles = [
  { size: "h-52 w-52", top: "12%", left: "8%", delay: 0, duration: 8 },
  { size: "h-64 w-64", top: "60%", left: "72%", delay: 1, duration: 11 },
  { size: "h-44 w-44", top: "30%", left: "80%", delay: 0.4, duration: 9 },
  { size: "h-32 w-32", top: "70%", left: "18%", delay: 1.4, duration: 10 },
];

function BackgroundEffects() {
  return (
    <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(45,212,255,0.12),transparent_45%),radial-gradient(circle_at_80%_15%,rgba(139,92,246,0.18),transparent_35%),radial-gradient(circle_at_60%_80%,rgba(57,128,255,0.14),transparent_35%)]" />
      <div className="absolute inset-0 bg-hero-grid bg-[size:36px_36px] opacity-20" />

      {bubbles.map((bubble, index) => (
        <motion.div
          key={index}
          className={`absolute ${bubble.size} rounded-full bg-cyan-300/20 blur-3xl`}
          style={{ top: bubble.top, left: bubble.left }}
          animate={{
            y: [0, -22, 0],
            x: [0, 8, 0],
            opacity: [0.3, 0.55, 0.3],
          }}
          transition={{
            duration: bubble.duration,
            delay: bubble.delay,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      ))}
    </div>
  );
}

export default BackgroundEffects;
